export default __webpack_public_path__ + "static/media/home-service-logo.899a7c75.svg";